export const defaultOption = {
  label: 'Tất cả',
  value: '--',
};
